import React from 'react';
import { Mail } from 'lucide-react';
import Button from '../../common/Button';
import { useEmailService } from '../../../hooks/useEmailService';
import { APP_CONFIG } from '../../../utils/constants';
import styles from './SupportSection.module.css';

const SupportSection = () => {
  const { openSupport } = useEmailService();

  return (
    <section className={styles.support}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <Mail className={styles.icon} />
          </div>

          <h2 className={styles.title}>Need Help?</h2>

          <p className={styles.description}>
            Having an issue with Subwise? Reach out and we'll get back to you as soon as possible.
          </p>

          <div className={styles.buttonWrapper}>
            <Button
              onClick={openSupport}
              size="lg"
              variant="primary"
              className={styles.supportButton}
            >
              Contact Support
            </Button>
          </div>

          <p className={styles.email}>{APP_CONFIG.supportEmail}</p>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
